export const AUTH = {
  registerEmail: 'auth-register-email',
  registerPassword: 'auth-register-password',
  registerFullName: 'auth-register-full-name',
  registerCompany: 'auth-register-company',
  registerPhone: 'auth-register-phone',
  registerSubmit: 'auth-register-submit',

  loginEmail: 'auth-login-email',
  loginPassword: 'auth-login-password',
  loginSubmit: 'auth-login-submit',
  logoutBtn: 'auth-logout-btn',
};

export const TRADE = {
  dashboard: 'trade-dashboard',
  navOrders: 'trade-nav-orders',
  navPlaceOrder: 'trade-nav-place-order',
  placeOrderTestId: (id) => `trade-test-${id}`,
  placeOrderQuantity: 'trade-place-order-quantity',
  placeOrderWhiteLabel: 'trade-place-order-white-label',
  placeOrderClientName: 'trade-place-order-client-name',
  placeOrderClientAddress: 'trade-place-order-client-address',
  placeOrderSubmit: 'trade-place-order-submit',
};

export const ADMIN = {
  usersTable: 'admin-users-table',
  approveBtn: (id) => `admin-approve-${id}`,
  rejectBtn: (id) => `admin-reject-${id}`,
};

export const BLOG = {
  hubLink: 'blog-hub-link',
  articleCard: (slug) => `article-card-${slug}`,
  articleBody: 'article-body',
};

export const SEO = {
  suburbHero: 'seo-suburb-hero',
  suburbBookBtn: 'seo-suburb-book-btn',
};
